import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
// import $ from 'jquery'
import { nextTick } from 'vue';
import $ from 'jquery';
export default {
  name: 'App',
  data: function data() {
    return {
      transitionName: '',
      onLine: navigator.onLine
    };
  },
  watch: {
    '$route': function $route(to, from) {
      var isBack = this.$router.isBack; //  监听路由变化时的状态为前进还是后退
      if (to.meta.index && from.meta.index) {
        if (to.meta.index > from.meta.index) {
          // 设置动画名称
          this.transitionName = 'slide-left';
        } else {
          this.transitionName = 'slide-right';
        }
        return;
      }
      if (isBack) {
        console.log(isBack, from, to, 'from, to');
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = 'slide-left';
      }
      this.$router.isBack = false;
    }
  },
  methods: {
    updateOnlineStatus: function updateOnlineStatus(e) {
      var type = e.type;
      this.onLine = type === 'online';
      if (this.onLine == false) {
        // eslint-disable-line
        var lan = JSON.parse(localStorage.getItem('appParams')).language.replace(/\"/g, '');
        if (lan === 'en') {
          _Toast('The network is not available, please check the network.');
        } else {
          _Toast('เครือข่ายไม่พร้อมใช้งาน กรุณาตรวจสอบเครือข่าย');
        }
      }
      console.log('网络由异常');
    },
    Refresh: function Refresh() {
      // location.reload();
      if (this.onLine == true) {
        // eslint-disable-line
        location.reload();
      } else {
        var lan = JSON.parse(localStorage.getItem('appParams')).language.replace(/\"/g, '');
        if (lan === 'en') {
          _Toast('The network is not available, please check the network.');
        } else {
          _Toast('เครือข่ายไม่พร้อมใช้งาน กรุณาตรวจสอบเครือข่าย');
        }
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('online', this.updateOnlineStatus); // 网络由异常到正常时触发
    window.addEventListener('offline', this.updateOnlineStatus); // 网络由正常常到异常时触发
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  }
};